// extracted by mini-css-extract-plugin
export default {"uploader":"AudioUpload_uploader__Z1mXu","upload":"AudioUpload_upload__W+pqo","audioContainer":"AudioUpload_audioContainer__Rsqp1","audioFile":"AudioUpload_audioFile__bjoSs"};